import Button from '@app-studio-web/ui/components/Button'
import PageLayout from '@app-studio-web/ui/components/PageLayout'
import { ClockIcon } from '@heroicons/react/24/outline'
import { getAllAnswers } from '@utils/onboardingStorage'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'

type AgeGroup = 'young' | 'midlife' | 'senior'

function getAgeGroup(birthYear: number): AgeGroup {
  const age = new Date().getFullYear() - birthYear
  if (age < 40) return 'young'
  if (age < 65) return 'midlife'
  return 'senior'
}

export default function AgeRiskFactPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const ageGroup = useMemo<AgeGroup>(() => {
    const answers = getAllAnswers()
    const birthYear = parseInt(answers.birth_year?.answer_key || '0', 10)
    if (!birthYear) return 'midlife'
    return getAgeGroup(birthYear)
  }, [])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    submit(event.currentTarget)
  }

  return (
    <PageLayout
      background={{
        gradient:
          'linear-gradient(to bottom, #c8d5b9 0%, #ddd5c7 50%, #e8d4c8 100%)',
      }}
    >
      <Form
        className="flex h-full min-h-[calc(100dvh-7rem)] flex-col"
        method="post"
        onSubmit={handleSubmit}
      >
        <div className="flex flex-1 flex-col items-center justify-center text-center">
          <div className="animate-bounce-gentle mb-8 flex h-16 w-16 items-center justify-center rounded-full bg-neutral-800">
            <ClockIcon className="h-8 w-8 text-white" />
          </div>

          <h1 className="custom-heading font-headline mb-4 max-w-sm text-3xl leading-tight font-normal text-balance">
            {t(`pages.onboarding.ageRiskFact.${ageGroup}.heading`)}
          </h1>

          <p className="max-w-xs text-sm text-neutral-600">
            {t(`pages.onboarding.ageRiskFact.${ageGroup}.description`)}
          </p>
        </div>

        <div className="mt-8 mb-8">
          <Button
            data-testid="button-continue"
            title={t('shared.continue')}
            type="submit"
          />
        </div>
      </Form>
    </PageLayout>
  )
}
